import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router} from 'react-router-dom';
import AppWrapper from "./AppWrapper";
/*
* Application was made in React JS with styling css Semantic UI
* Any questions or concerns please contact Roderick Tabalba at tabalbar@hawaii.edu
* */

ReactDOM.render(
  <Router>
    <AppWrapper />
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
